import Axios from "axios";
import {
    SET_ROLE_LIST,
    UNSET_ROLE_LIST,
    SET_MODULE_BY_BRANCH,
    UNSET_MODULE_BY_BRANCH
  } from "@/store/mutation-types";
import { saveUpdateRole, getRoleList, getModulesByBranch, deleteRole  } from "@/store/api";
// initial state
const state = {
  getRoleList: [],
  getModulesByBranch: [],
};

const getters = {
  getRoleList(state) {
    return state.getRoleList;
  },
  getModulesByBranch(state) {
    return state.getModulesByBranch;
  },
};
const mutations = {
  [SET_ROLE_LIST](state, data) {
    state.getRoleList = data;
  },
  [UNSET_ROLE_LIST](state) {
    state.getRoleList = [];
  },
  [SET_MODULE_BY_BRANCH](state, data) {
    state.getModulesByBranch = data;
  },
  [UNSET_MODULE_BY_BRANCH](state) {
    state.getModulesByBranch = [];
  },

};

const actions = {

  saveUpdateRole({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateRole, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getRoleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getRoleList, data)
        .then(function (response) {
          commit('SET_ROLE_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_ROLE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getModulesByBranch({ state, commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise(function (resolve, reject) {
    Axios.post(getModulesByBranch, {branch_id:data})
        .then((response) => {
            commit('SET_MODULE_BY_BRANCH',response.data.data)
            resolve(response);  
        })
        .catch((error) => {
            commit('UNSET_MODULE_BY_BRANCH')
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  deleteRole({ state, commit }, data) {
    commit("SET_LOADING", {color: "warning"});
    return new Promise(function (resolve, reject) {
    Axios.post(deleteRole, {id:data})
        .then((response) => {
            resolve(response);  
        })
        .catch((error) => {
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
